import React, { useMemo, useState } from 'react';

const AdminResetPasswordModal = ({ user, onClose, onConfirm }) => {
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [error, setError] = useState('');

  const canSubmit = useMemo(() => {
    return password.trim().length >= 8 && password === confirm;
  }, [password, confirm]);

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h3 style={{ margin: 0 }}>Reset password</h3>
          <button className="modal-close" onClick={onClose}>×</button>
        </div>

        <div className="modal-body">
          {error && (
            <div className="alert alert-error" style={{ marginBottom: '12px' }}>
              <span>{error}</span>
            </div>
          )}

          <div style={{ fontSize: '13px', color: '#555', marginBottom: '12px' }}>
            User: <strong>{user?.email || user?.id}</strong>
          </div>

          <div style={{ display: 'grid', gap: '10px' }}>
            <div>
              <label style={{ fontSize: '12px', color: '#555' }}>New password</label>
              <input
                type="password"
                value={password}
                onChange={(e) => {
                  setPassword(e.target.value);
                  setError('');
                }}
                style={{ width: '100%', padding: '8px 10px', borderRadius: '8px', border: '1px solid #e0e0e0' }}
              />
              <div style={{ fontSize: '12px', color: '#777', marginTop: '6px' }}>Minimum 8 characters.</div>
            </div>

            <div>
              <label style={{ fontSize: '12px', color: '#555' }}>Confirm new password</label>
              <input
                type="password"
                value={confirm}
                onChange={(e) => {
                  setConfirm(e.target.value);
                  setError('');
                }}
                style={{ width: '100%', padding: '8px 10px', borderRadius: '8px', border: '1px solid #e0e0e0' }}
              />
            </div>
          </div>

          <div style={{ display: 'flex', gap: '10px', justifyContent: 'flex-end', marginTop: '14px' }}>
            <button className="action-btn" onClick={onClose} style={{ background: '#6c757d' }}>
              Cancel
            </button>
            <button
              className="action-btn"
              onClick={() => {
                if (password.trim().length < 8) {
                  setError('Password must be at least 8 characters.');
                  return;
                }
                if (password !== confirm) {
                  setError('Passwords do not match.');
                  return;
                }
                onConfirm(password);
              }}
              disabled={!canSubmit}
              style={{ background: '#2C341B', opacity: canSubmit ? 1 : 0.6 }}
            >
              Reset password
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminResetPasswordModal;
